import React from 'react';
import cns from 'classnames';

import VerbText from '../../../shared/components/VerbText';

export default function NavItemNoIcon(props) {
    const { textId, isSelected, hiddenXS = true, defaultMessage, customClass = '' } = props;
    const translatedText = (
        <VerbText
            className={cns({ selected: isSelected }, { 'hidden-xs': hiddenXS })}
            messageId={textId}
            defaultMessage={defaultMessage}
        />
    );
    const navText = textId ? (
        <small key={textId} className={cns('navbar-section-title-no-icon', customClass)}>
            {translatedText}
        </small>
    ) : null;
    return navText;
}
